import { SELECT_COURSE } from "./course.types";

export default function selectedCourse(state={}, action) {
	switch (action.type) {
		case SELECT_COURSE:
			return action.course;
	  
		default:
		  return state;
   }
   
}
